import { Identity } from 'embedded/api/out/Identity';
import { Listener } from 'embedded/api/out/Listener';
import { Store } from 'redux';
import { v4 as uuid } from 'uuid';
import { OutMessage, OutMessagePayload } from 'embedded/api/out/OutMessage';
import { OutMessageTopic } from 'embedded/api/out/OutMessageTopic';
import { LoginStatus } from 'login/store/LoginState';
import { selectLoginState } from 'login/store/selectors';

export interface AuthenticationStatusChangedMessagePayload
    extends OutMessagePayload {
    status: LoginStatus;
}

export type AuthenticationStatusChangedMessage = OutMessage<
    'AUTHENTICATION_STATUS_CHANGED',
    AuthenticationStatusChangedMessagePayload
>;

export const authenticationStatusChangedTopic: OutMessageTopic<AuthenticationStatusChangedMessagePayload> =
    {
        subscriptions: [],
        publishOnSubscribe: authenticationStatusChangedPublishOnSubscribe,
    };

export function authenticationStatusChangedPublishOnSubscribe(
    identity: Identity,
    listener: Listener<AuthenticationStatusChangedMessagePayload>,
    store: Store
): void {
    const loginState = selectLoginState(store.getState());
    listener({ status: loginState.status, correlationId: uuid() });
}
